import { Button } from '@progress/kendo-react-buttons';
import type { SamplingDateToolbarCtrlProps } from './sampling-date-toolbar-ctrl.types.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { SamplingDateToolbarPicker } from './sampling-date-toolbar-picker.tsx';
import { formatDate } from '@progress/kendo-intl';
import styles from './sampling-date-toolbar-ctrl.module.scss';

export function SamplingDateToolbarCtrl({
  selectedDate,
  weekStart,
  weekEnd,
  onPrevWeek,
  onNextWeek,
  onChange,
}: SamplingDateToolbarCtrlProps) {
  return (
    <div className={styles.container}>
      <Button themeColor={'primary'} className={`${styles.btn} ${styles.iconBtn}`} onClick={onPrevWeek}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </Button>
      <div className={styles.title}>{`${formatDate(weekStart, 'd MMM')} – ${formatDate(weekEnd, 'd MMM yy')}`}</div>
      <SamplingDateToolbarPicker selectedDate={selectedDate} onChange={onChange} />
      <Button themeColor={'primary'} className={`${styles.btn} ${styles.iconBtn}`} onClick={onNextWeek}>
        <FontAwesomeIcon icon={faArrowRight} />
      </Button>
    </div>
  );
}
